import * as React from 'react';
import { styled } from '@linaria/react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  ref?: React.RefObject<HTMLDivElement>;
  backgroundColor?: string;
  glassColor: string;
  opacity?: number;
  children?: React.ReactNode;
}

function GlassyBackdrop({
  ref,
  backgroundColor,
  glassColor,
  opacity = 1,
  children,
  style = {},
  ...delegated
}: Props) {
  return (
    <Wrapper
      ref={ref}
      style={{
        '--fade-to-color': backgroundColor || 'transparent',
        '--glass-color': glassColor,
        '--blur-amount': '8px',
        opacity,
        ...style,
      }}
      data-id="glassy-backdrop"
      {...delegated}
    >
      <Backdrop
        style={{
          opacity,
        }}
      />
      <ChildWrapper>{children}</ChildWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  background: linear-gradient(
    to top,
    transparent 0%,
    var(--fade-to-color) 100%
  );
`;

const Backdrop = styled.div`
  --extended-by: 100px;
  --cutoff: calc(100% - var(--extended-by));
  position: absolute;
  inset: 0;
  bottom: calc(var(--extended-by) * -1);
  background: hsl(from var(--glass-color) h s l / 0.7);
  -webkit-mask-image: linear-gradient(
    to bottom,
    black 0,
    black var(--cutoff),
    transparent var(--cutoff)
  );
  mask-image: linear-gradient(
    to bottom,
    black 0,
    black var(--cutoff),
    transparent var(--cutoff)
  );

  backdrop-filter: blur(var(--blur-amount));
  pointer-events: none;
  transition: opacity 600ms;
`;

const ChildWrapper = styled.div`
  position: relative;
`;

export default GlassyBackdrop;
